function handleFooterLinkClick(href) {
  if (!href) return
  window.location.href = href
}

function initFooterLinks() {
  const footerLinks = document.querySelectorAll('footer .js-footer-link[data-grid-cat]')

  if (!footerLinks) return
  footerLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()
      handleFooterLinkClick(link.getAttribute('href'))
    })
  })
}
initFooterLinks()
